
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { vendorArtistApi, publicApi, getImageUrl } from "../../lib/api";
import { Panel, MetricCard, EmptyState, StatusBadge } from "./vendorShared";
import { normalizeBooking, notifications } from "../../utils/vendor/vendorUtils";
import BookingExperience from "../BookingExperience";
// import specialistImage from "../../assets/spec1.png";

const isSuccessMessage = (msg) => {
    if (!msg) return false;
    const lower = msg.toLowerCase();
    return lower.includes("success") ||
        lower.includes("saved") ||
        lower.includes("updated") ||
        lower.includes("created") ||
        lower.includes("deleted") ||
        lower.includes("loaded") ||
        lower.includes("sent") ||
        lower.includes("verified");
};

export function DashboardOverview({ setActiveTab, dashboardData }) {
    console.log("Function called: DashboardOverview");
    const liveBookings = dashboardData.bookings.map(normalizeBooking);
    const liveMetrics = [
        {
            label: "Upcoming bookings",
            value: String(dashboardData.stats?.bookings?.total ?? dashboardData.bookings.length),
            // note: "",
            icon: "fa-calendar-check",
        },
        // {
        //     label: "Revenue",
        //     value: "$0",
        //     note: "Revenue API not available yet",
        //     icon: "fa-chart-line",
        // },
        {
            label: "New customers",
            value: String(dashboardData.users.length),
            // note: "From backend users",
            icon: "fa-user-plus",
        },
        // {
        //     label: "Artists",
        //     value: String(dashboardData.stats?.artists ?? dashboardData.artists.length),
        //     note: "Backend artist count",
        //     icon: "fa-eye",
        // },
    ];

    return (
        <div className="space-y-6">
            <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                {liveMetrics.map((metric) => (
                    <MetricCard key={metric.label} metric={metric} />
                ))}
            </div>

            <div className="grid gap-6 xl:grid-cols-[1.15fr_0.85fr]">
                <Panel
                    title="Today's schedule"
                    eyebrow="Calendar"
                // action={
                //     <button
                //         type="button"
                //         onClick={() => setActiveTab("calendar")}
                //         className="h-10 rounded-lg border border-blue-200 px-4 text-sm font-bold text-blue-700 transition hover:bg-blue-50"
                //     >
                //         Manage availability
                //     </button>
                // }
                >
                    <div className="space-y-3">
                        {liveBookings.length > 0 ? (
                            liveBookings.slice(0, 3).map((booking) => (
                                <div key={`${booking.id || booking.client}-${booking.time}`} className="flex flex-col gap-3 rounded-xl border border-slate-100 p-4 sm:flex-row sm:items-center sm:justify-between">
                                    <div className="flex items-start gap-3">
                                        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-blue-50 text-blue-700">
                                            <i className="fa-regular fa-clock" aria-hidden="true" />
                                        </span>
                                        <div>
                                            <p className="font-bold text-slate-900">{booking.client}</p>
                                            <p className="text-sm text-slate-500">{booking.service}</p>
                                        </div>
                                    </div>
                                    <div className="text-left sm:text-right">
                                        <p className="font-bold text-slate-900">{booking.time}</p>
                                        <StatusBadge tone={booking.status === "Pending" ? "amber" : "green"}>{booking.status}</StatusBadge>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <EmptyState title="No Bookings yet" message="Bookings will appear here once customers book services." />
                        )}
                    </div>
                </Panel>

                <Panel
                    title="Profile readiness"
                    eyebrow="Profile"
                    action={
                        <button
                            type="button"
                            onClick={() => setActiveTab("profile")}
                            className="h-10 rounded-lg border border-blue-200 px-4 text-sm font-bold text-blue-700 transition hover:bg-blue-50"
                        >
                            Customize profile
                        </button>
                    }
                >
                    <div className="space-y-5">
                        <div>
                            <div className="flex items-center justify-between text-sm font-bold text-slate-700">
                                <span>Public profile</span>
                                <span>82%</span>
                            </div>
                            <div className="mt-3 h-3 rounded-full bg-slate-100">
                                <div className="h-3 w-[82%] rounded-full bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF]" />
                            </div>
                        </div>

                        {[
                            "Bio and profile photo",
                            "Service pricing",
                            "Portfolio gallery",
                            "Booking link published",
                        ].map((item, index) => (
                            <div key={item} className="flex items-center gap-3 text-sm font-semibold text-slate-700">
                                <span className={`grid h-6 w-6 place-items-center rounded-full ${index < 4 ? "bg-emerald-50 text-emerald-700" : "bg-blue-50 text-blue-700"}`}>
                                    <i className={`fa-solid ${index < 4 ? "fa-check" : "fa-hourglass-half"} text-[10px]`} aria-hidden="true" />
                                </span>
                                {item}
                            </div>
                        ))}
                    </div>
                </Panel>
            </div>

            <Panel title="Notifications" eyebrow="Email">
                <div className="grid gap-3 md:grid-cols-3">
                    {notifications.map((item) => (
                        <div key={item} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                            <i className="fa-regular fa-envelope text-blue-700" aria-hidden="true" />
                            <p className="mt-3 text-sm font-semibold leading-6 text-slate-700">{item}</p>
                        </div>
                    ))}
                </div>
            </Panel>
        </div>
    );
}

export function ProfilePanel({ profile, onProfileSaved }) {
    console.log("Function called: ProfilePanel");
    const [profileForm, setProfileForm] = useState({
        name: profile?.name || "",
        address: profile?.address || "",
        city: profile?.city || "",
        state: profile?.state || "",
        zipcode: profile?.zipcode || "",
        bio: profile?.bio || "",
    });
    const [isSavingProfile, setIsSavingProfile] = useState(false);
    const [profileMessage, setProfileMessage] = useState("");
    const [passwordForm, setPasswordForm] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [isChangingPassword, setIsChangingPassword] = useState(false);
    const [passwordMessage, setPasswordMessage] = useState("");

    // Branding settings state
    const [brandingEdit, setBrandingEdit] = useState(false);
    const [brandingForm, setBrandingForm] = useState({
        online_booking: profile?.branding_settings?.online_booking ?? true,
        cancellation_policy: profile?.branding_settings?.cancellation_policy || "24 hours",
        portfolio_gallery: profile?.branding_settings?.portfolio_gallery || [],
        profile_photo: profile?.branding_settings?.profile_photo || null,
    });
    const [newPortfolioUrl, setNewPortfolioUrl] = useState("");
    const [isSavingBranding, setIsSavingBranding] = useState(false);
    const [brandingMessage, setBrandingMessage] = useState("");
    const [profilePhotoFile, setProfilePhotoFile] = useState(null);

    useEffect(() => {
        console.log("useEffect triggered");
        if (!profile) return;
        setProfileForm({
            name: profile.name || "",
            address: profile.address || "",
            city: profile.city || "",
            state: profile.state || "",
            zipcode: profile.zipcode || "",
            bio: profile.bio || "",
        });
        const bs = profile.branding_settings || {};
        setBrandingForm({
            online_booking: bs.online_booking ?? true,
            cancellation_policy: bs.cancellation_policy || "24 hours",
            portfolio_gallery: bs.portfolio_gallery || [],
            profile_photo: bs.profile_photo || null,
        });
    }, [profile]);

    const updateProfileField = (field) => (event) => {
        setProfileForm((current) => ({ ...current, [field]: event.target.value }));
    };

    const updatePasswordField = (field) => (event) => {
        setPasswordForm((current) => ({ ...current, [field]: event.target.value }));
    };

    const saveProfile = async () => {
        console.log("Function called: saveProfile");
        setProfileMessage("");
        setIsSavingProfile(true);
        try {
            const response = await vendorArtistApi.updateProfile(profileForm);
            onProfileSaved(response.data);
            setProfileMessage("Profile saved successfully.");
        } catch (error) {
            console.error("Error caught:", error);
            setProfileMessage(error.message || "Unable to save profile.");
        } finally {
            setIsSavingProfile(false);
        }
    };

    const changePassword = async () => {
        console.log("Function called: changePassword");
        setPasswordMessage("");

        if (!passwordForm.oldPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
            setPasswordMessage("All password fields are required.");
            return;
        }

        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            setPasswordMessage("New passwords do not match.");
            return;
        }

        setIsChangingPassword(true);
        try {
            const response = await vendorArtistApi.changePassword(passwordForm);
            setPasswordForm({ oldPassword: "", newPassword: "", confirmPassword: "" });
            setPasswordMessage(response.message || "Password updated successfully.");
        } catch (error) {
            console.error("Error caught:", error);
            setPasswordMessage(error.message || "Unable to update password.");
        } finally {
            setIsChangingPassword(false);
        }
    };

    const saveBranding = async () => {
        setIsSavingBranding(true);
        setBrandingMessage("");
        try {
            let updatedPhotoUrl = brandingForm.profile_photo;

            // Upload profile photo if a file was selected
            if (profilePhotoFile) {
                const fd = new FormData();
                fd.append("profilePhoto", profilePhotoFile);
                try {
                    const uploadRes = await vendorArtistApi.uploadProfilePhoto(fd);
                    updatedPhotoUrl = uploadRes.url || uploadRes.imageUrl || uploadRes.data?.url || updatedPhotoUrl;
                } catch (uploadErr) {
                    setBrandingMessage("Image upload failed: " + (uploadErr.message || "Unknown error"));
                    setIsSavingBranding(false);
                    return;
                }
            }

            const updatedBranding = { ...brandingForm, profile_photo: updatedPhotoUrl };
            const response = await vendorArtistApi.updateProfile({ branding_settings: updatedBranding });
            onProfileSaved(response.data);
            setBrandingForm(updatedBranding);
            setProfilePhotoFile(null);
            setBrandingMessage("Branding settings saved successfully.");
            setBrandingEdit(false);
        } catch (error) {
            setBrandingMessage(error.message || "Unable to save branding settings.");
        } finally {
            setIsSavingBranding(false);
        }
    };

    const addPortfolioUrl = () => {
        const url = newPortfolioUrl.trim();
        if (!url) return;
        setBrandingForm((prev) => ({
            ...prev,
            portfolio_gallery: [...(prev.portfolio_gallery || []), url],
        }));
        setNewPortfolioUrl("");
    };

    const removePortfolioUrl = (idx) => {
        setBrandingForm((prev) => ({
            ...prev,
            portfolio_gallery: prev.portfolio_gallery.filter((_, i) => i !== idx),
        }));
    };

    return (
        <div className="grid gap-6 xl:grid-cols-[1fr_360px]">
            <Panel title="Professional profile" eyebrow="Profile customization">
                <div className="grid gap-4 md:grid-cols-2">
                    <label className="block md:col-span-2">
                        <span className="text-sm font-bold text-slate-700">Business name</span>
                        <input
                            value={profileForm.name || ""}
                            onChange={updateProfileField("name")}
                            className="mt-2 h-11 w-full rounded-xl border border-slate-200 px-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        />
                    </label>

                    <label className="block">
                        <span className="text-sm font-bold text-slate-700">Service area</span>
                        <input value={[profileForm.city, profileForm.state].filter(Boolean).join(", ")} readOnly className="mt-2 h-11 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 text-sm font-semibold outline-none" />
                    </label>

                    <label className="block">
                        <span className="text-sm font-bold text-slate-700">City</span>
                        <input
                            value={profileForm.city || ""}
                            onChange={updateProfileField("city")}
                            className="mt-2 h-11 w-full rounded-xl border border-slate-200 px-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        />
                    </label>

                    <label className="block">
                        <span className="text-sm font-bold text-slate-700">State</span>
                        <input
                            value={profileForm.state || ""}
                            onChange={updateProfileField("state")}
                            className="mt-2 h-11 w-full rounded-xl border border-slate-200 px-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        />
                    </label>

                    <label className="block md:col-span-2">
                        <span className="text-sm font-bold text-slate-700">Address</span>
                        <input
                            value={profileForm.address || ""}
                            onChange={updateProfileField("address")}
                            className="mt-2 h-11 w-full rounded-xl border border-slate-200 px-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        />
                    </label>

                    <label className="block md:col-span-2">
                        <span className="text-sm font-bold text-slate-700">Zipcode</span>
                        <input
                            value={profileForm.zipcode || ""}
                            onChange={updateProfileField("zipcode")}
                            className="mt-2 h-11 w-full rounded-xl border border-slate-200 px-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        />
                    </label>

                    <label className="block md:col-span-2">
                        <span className="text-sm font-bold text-slate-700">Bio (shows on public booking page subtitle)</span>
                        <textarea
                            value={profileForm.bio || ""}
                            onChange={updateProfileField("bio")}
                            rows={3}
                            placeholder="Introduce yourself or highlight your services..."
                            className="mt-2 w-full rounded-xl border border-slate-200 p-4 text-sm font-semibold outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100 resize-none"
                        />
                    </label>
                </div>

                {profileMessage && (
                    <div className={`mt-4 rounded-xl border px-4 py-3 text-sm font-bold ${isSuccessMessage(profileMessage) ? "border-emerald-100 bg-emerald-50 text-emerald-700" : "border-red-100 bg-red-50 text-red-700"}`}>
                        {profileMessage}
                    </div>
                )}

                <div className="mt-5 flex flex-wrap gap-3">
                    <button
                        type="button"
                        onClick={saveProfile}
                        disabled={isSavingProfile}
                        className="h-10 rounded-lg bg-blue-600 px-4 text-sm font-bold text-white shadow-lg shadow-blue-100 transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-70"
                    >
                        {isSavingProfile ? "Saving..." : "Save profile"}
                    </button>
                </div>
            </Panel>

            <Panel title="Public page settings" eyebrow="Branding">
                <div className="space-y-4">
                    {/* Profile photo */}
                    <div className="flex items-center justify-between rounded-xl border border-slate-100 bg-slate-50 p-4">
                        <div>
                            <span className="text-sm font-bold text-slate-700">Profile photo</span>
                            {brandingForm.profile_photo && (
                                <img src={getImageUrl(brandingForm.profile_photo)} alt="Profile" className="mt-2 h-10 w-10 rounded-full object-cover border border-slate-200" />
                            )}
                        </div>
                        <StatusBadge tone={brandingForm.profile_photo ? "green" : "amber"}>
                            {brandingForm.profile_photo ? "Uploaded" : "Not set"}
                        </StatusBadge>
                    </div>

                    {/* Portfolio gallery */}
                    {/* <div className="flex items-center justify-between rounded-xl border border-slate-100 bg-slate-50 p-4">
                        <span className="text-sm font-bold text-slate-700">Portfolio gallery</span>
                        <StatusBadge tone="blue">{(brandingForm.portfolio_gallery || []).length} image{(brandingForm.portfolio_gallery || []).length !== 1 ? "s" : ""}</StatusBadge>
                    </div> */}

                    {/* Online booking */}
                    {/* <div className="flex items-center justify-between rounded-xl border border-slate-100 bg-slate-50 p-4">
                        <span className="text-sm font-bold text-slate-700">Online booking</span>
                        <StatusBadge tone={brandingForm.online_booking ? "green" : "amber"}>
                            {brandingForm.online_booking ? "Enabled" : "Disabled"}
                        </StatusBadge>
                    </div> */}
                </div>

                <button
                    type="button"
                    onClick={() => { setBrandingEdit((v) => !v); setBrandingMessage(""); }}
                    className="mt-5 h-10 w-full rounded-lg border border-blue-200 text-sm font-bold text-blue-700 transition hover:bg-blue-50"
                >
                    {brandingEdit ? "Cancel editing" : "Edit branding"}
                </button>

                {brandingEdit && (
                    <div className="mt-5 space-y-4 rounded-2xl border border-blue-100 bg-blue-50/50 p-4">

                        {/* Profile photo upload */}
                        <label className="block">
                            <span className="text-xs font-bold text-slate-700">Profile photo</span>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => setProfilePhotoFile(e.target.files[0])}
                                className="mt-1.5 block w-full text-xs text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-blue-600 file:px-3 file:py-2 file:text-xs file:font-bold file:text-white hover:file:bg-blue-700"
                            />
                            {profilePhotoFile && <p className="mt-1 text-xs text-emerald-600 font-semibold">Selected: {profilePhotoFile.name}</p>}
                        </label>

                        {/* Portfolio gallery
                        <div>
                            <span className="text-xs font-bold text-slate-700">Portfolio gallery URLs</span>
                            <div className="mt-2 space-y-2">
                                {(brandingForm.portfolio_gallery || []).map((url, idx) => (
                                    <div key={idx} className="flex items-center gap-2">
                                        <input
                                            value={url}
                                            readOnly
                                            className="h-9 flex-1 rounded-xl border border-slate-200 bg-white px-3 text-xs font-semibold text-slate-600 outline-none truncate"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => removePortfolioUrl(idx)}
                                            className="grid h-9 w-9 shrink-0 place-items-center rounded-xl border border-red-200 text-red-600 hover:bg-red-50 transition"
                                        >
                                            <i className="fa-solid fa-xmark text-xs" />
                                        </button>
                                    </div>
                                ))}
                                <div className="flex items-center gap-2">
                                    <input
                                        type="url"
                                        value={newPortfolioUrl}
                                        onChange={(e) => setNewPortfolioUrl(e.target.value)}
                                        placeholder="https://example.com/photo.jpg"
                                        className="h-9 flex-1 rounded-xl border border-slate-200 bg-white px-3 text-xs font-semibold outline-none focus:border-blue-500"
                                    />
                                    <button
                                        type="button"
                                        onClick={addPortfolioUrl}
                                        className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition"
                                    >
                                        <i className="fa-solid fa-plus text-xs" />
                                    </button>
                                </div>
                            </div>
                        </div> */}

                        {brandingMessage && (
                            <div className={`rounded-xl border px-4 py-3 text-sm font-bold ${brandingMessage.includes("success") ? "border-emerald-100 bg-emerald-50 text-emerald-700" : "border-red-100 bg-red-50 text-red-700"}`}>
                                {brandingMessage}
                            </div>
                        )}

                        <button
                            type="button"
                            onClick={saveBranding}
                            disabled={isSavingBranding}
                            className="h-10 w-full rounded-lg bg-blue-600 text-sm font-bold text-white shadow-lg shadow-blue-100 transition hover:bg-blue-700 disabled:opacity-70"
                        >
                            {isSavingBranding ? "Saving branding..." : "Save branding settings"}
                        </button>
                    </div>
                )}

            </Panel>
        </div>
    );
}

const getFriendlyErrorMessage = (errorMsg) => {
    if (!errorMsg) return "An unexpected error occurred. Please try again.";
    const lower = errorMsg.toLowerCase();
    if (lower.includes("failed to fetch") || lower.includes("networkerror") || lower.includes("inbound response pipeline")) {
        return "We are unable to reach our services. Please check your internet connection or try again shortly.";
    }
    if (lower.includes("unexpected token") || lower.includes("json") || lower.includes("parsing")) {
        return "The server returned an unreadable response. This might be a temporary issue; please try again shortly.";
    }
    return errorMsg;
};

export function SubscriptionPanel({ profile }) {
    console.log("Function called: SubscriptionPanel");
    const [selectedPlan, setSelectedPlan] = useState("");
    const [checkoutError, setCheckoutError] = useState("");
    const [isCheckingOut, setIsCheckingOut] = useState(false);
    const [invoicesList, setInvoicesList] = useState([]);
    const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);
    const [invoiceError, setInvoiceError] = useState("");
    const [plansList, setPlansList] = useState([]);
    const [isLoadingPlans, setIsLoadingPlans] = useState(false);
    const [plansError, setPlansError] = useState("");

    const currentPlan = profile?.subscription_plan || "trial";
    const trialEnds = profile?.trial_ends_at ? new Date(profile.trial_ends_at).toLocaleDateString() : "N/A";

    const [showAllPlans, setShowAllPlans] = useState(currentPlan === "trial");

    const otherPlans = plansList.filter(
        (item) => item.name.toLowerCase() !== currentPlan.toLowerCase() &&
            item.stripe_price_id !== currentPlan
    );

    useEffect(() => {
        if (currentPlan === "trial") {
            setShowAllPlans(true);
        } else {
            setShowAllPlans(false);
        }

        const others = plansList.filter(
            (item) => item.name.toLowerCase() !== currentPlan.toLowerCase() &&
                item.stripe_price_id !== currentPlan
        );
        if (others.length > 0) {
            setSelectedPlan(others[0].stripe_price_id || others[0].name);
        }
    }, [currentPlan, plansList]);

    useEffect(() => {
        let isActive = true;
        setIsLoadingInvoices(true);
        setInvoiceError("");
        setIsLoadingPlans(true);
        setPlansError("");

        vendorArtistApi.getSaaSPlans()
            .then((response) => {
                if (!isActive) return;
                const plans = response.data || response || [];
                setPlansList(plans);
                const others = plans.filter(
                    (item) => item.name.toLowerCase() !== currentPlan.toLowerCase() &&
                        item.stripe_price_id !== currentPlan
                );
                if (others.length > 0) {
                    setSelectedPlan(others[0].stripe_price_id || others[0].name);
                }
            })
            .catch((error) => {
                if (!isActive) return;
                setPlansError(error.message || "Failed to load subscription plans.");
            })
            .finally(() => {
                if (!isActive) return;
                setIsLoadingPlans(false);
            });

        vendorArtistApi.getSaaSInvoices()
            .then((response) => {
                if (!isActive) return;
                setInvoicesList(response.data || []);
            })
            .catch((error) => {
                if (!isActive) return;
                setInvoiceError(error.message || "Failed to load payment history invoices.");
            })
            .finally(() => {
                if (!isActive) return;
                setIsLoadingInvoices(false);
            });

        return () => {
            isActive = false;
        };
    }, [currentPlan]);

    const handleCheckout = async () => {
        setCheckoutError("");
        try {
            if (!selectedPlan) {
                setCheckoutError("Please select a plan before initiating checkout.");
                return;
            }
            setIsCheckingOut(true);
            const returnUrl = window.location.origin;
            const response = await vendorArtistApi.triggerStripeCheckout(selectedPlan, returnUrl);
            if (response.success && response.url) {
                window.location.href = response.url;
            } else if (response.url) {
                window.location.href = response.url;
            } else {
                setCheckoutError("Unable to generate Stripe checkout URL. Please try again later.");
            }
        } catch (error) {
            setCheckoutError(error.message || "Failed starting checkout session.");
        } finally {
            setIsCheckingOut(false);
        }
    };

    const handleBillingPortal = async () => {
        setCheckoutError("");
        try {
            setIsCheckingOut(true);
            const returnUrl = window.location.origin;
            const response = await vendorArtistApi.triggerStripePortal(returnUrl);
            if (response.success && response.url) {
                window.location.href = response.url;
            } else if (response.url) {
                window.location.href = response.url;
            } else {
                setCheckoutError("Unable to build billing portal URL. Please try again later.");
            }
        } catch (error) {
            setCheckoutError(error.message || "Failed launching Stripe customer portal.");
        } finally {
            setIsCheckingOut(false);
        }
    };

    return (
        <div className="grid gap-6 xl:grid-cols-[0.9fr_1.1fr]">
            <Panel title="Stripe subscription" eyebrow="Billing">
                <div className="rounded-xl border border-blue-100 bg-blue-50 p-5">
                    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                            <p className="text-sm font-semibold text-slate-600">Billing details</p>
                        </div>
                        {/* <StatusBadge tone={currentStatus === "active" ? "green" : "slate"}>
                            {currentStatus.toUpperCase()}
                        </StatusBadge> */}
                    </div>

                    {/* Active Plan / Trial Card */}
                    {currentPlan === "trial" ? (
                        <div className="mt-4 p-4 rounded-xl border border-blue-200 bg-white/95 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="font-extrabold text-slate-900 text-lg">Trial Period</p>
                                </div>
                                <span className="text-xs font-extrabold text-blue-600 bg-blue-50 px-2 py-0.5 rounded border border-blue-200">
                                    Active
                                </span>
                            </div>
                            <div className="mt-3 text-sm text-slate-600 font-semibold">
                                Trial ends: {trialEnds}
                            </div>
                        </div>
                    ) : (
                        (() => {
                            const activePlanObj = plansList.find(
                                (item) => item.name.toLowerCase() === currentPlan.toLowerCase() ||
                                    item.stripe_price_id === currentPlan
                            );
                            if (activePlanObj) {
                                return (
                                    <div className="mt-4 p-4 rounded-xl border border-emerald-200 bg-white/95 shadow-sm">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="font-extrabold text-slate-900 text-lg capitalize">{activePlanObj.name}</p>
                                                <p className="mt-1 text-sm text-slate-500 font-semibold">
                                                    ${Number(activePlanObj.price).toFixed(2)}/{activePlanObj.interval === "month" ? "monthly" : "yearly"}
                                                </p>
                                            </div>
                                            <span className="text-xs font-extrabold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded border border-emerald-200 self-start">
                                                Active Plan
                                            </span>
                                        </div>
                                        {activePlanObj.description && (
                                            <p className="mt-3 text-xs text-slate-500 font-normal leading-relaxed">{activePlanObj.description}</p>
                                        )}
                                        <div className="mt-3 flex items-center gap-1.5 text-xs font-bold text-slate-500">
                                            <i className="fa-regular fa-clock text-slate-400" />
                                            <span>Billing cycle: Billed {activePlanObj.interval === "month" ? "monthly" : "yearly"}</span>
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="mt-4 p-4 rounded-xl border border-emerald-200 bg-white/95 shadow-sm">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="font-extrabold text-slate-900 text-lg capitalize">{currentPlan.replace("_", " ")}</p>
                                                <p className="mt-1 text-sm text-slate-500 font-semibold">SaaS subscription active</p>
                                            </div>
                                            <span className="text-xs font-extrabold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded border border-emerald-200">
                                                Active Plan
                                            </span>
                                        </div>
                                        <div className="mt-3 flex items-center gap-1.5 text-xs font-bold text-slate-500">
                                            <i className="fa-regular fa-clock text-slate-400" />
                                            <span>Billing cycle: Recurring</span>
                                        </div>
                                    </div>
                                );
                            }
                        })()
                    )}

                    {showAllPlans && (
                        <>
                            {isLoadingPlans && (
                                <div className="mt-4 text-sm font-bold text-blue-600">Loading plans...</div>
                            )}
                            {plansError && (
                                <div className="mt-4 rounded-xl bg-amber-50 p-3 text-sm font-bold text-amber-800">{plansError}</div>
                            )}
                            {!isLoadingPlans && otherPlans.length === 0 && (
                                <div className="mt-4 text-sm text-slate-500 font-semibold">No other plans available.</div>
                            )}
                            <div className="mt-5 grid gap-3 sm:grid-cols-2">
                                {otherPlans.map((item) => (
                                    <button
                                        type="button"
                                        key={item.id}
                                        onClick={() => setSelectedPlan(item.stripe_price_id || item.name)}
                                        className={`rounded-xl border p-4 text-left transition ${selectedPlan === (item.stripe_price_id || item.name) ? "border-blue-500 bg-white shadow-sm" : "border-blue-100 bg-white/70 hover:border-blue-300"
                                            }`}
                                    >
                                        <div className="flex items-center justify-between">
                                            <p className="font-extrabold text-slate-900">{item.name}</p>
                                            <span className="text-[10px] font-extrabold text-blue-600 bg-blue-50 border border-blue-100 px-2 py-0.5 rounded uppercase tracking-wider">
                                                {item.interval === "month" ? "Monthly" : "Yearly"}
                                            </span>
                                        </div>
                                        <p className="mt-2 text-sm text-slate-500">${Number(item.price).toFixed(2)}/{item.interval === "month" ? "monthly" : "yearly"}</p>
                                        {item.description && (
                                            <p className="mt-1 text-xs text-slate-400 font-normal line-clamp-2">{item.description}</p>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </>
                    )}

                    {checkoutError && (
                        <div className="mt-4 rounded-xl border border-red-150 bg-red-50 p-4 text-xs font-bold text-red-700 flex items-start gap-2 shadow-sm animate-shake">
                            <i className="fa-solid fa-triangle-exclamation mt-0.5 shrink-0 text-red-500 text-sm" />
                            <span>{getFriendlyErrorMessage(checkoutError)}</span>
                        </div>
                    )}

                    <div className="mt-5 grid gap-3 sm:grid-cols-2">
                        {showAllPlans ? (
                            <>
                                <button
                                    type="button"
                                    onClick={handleCheckout}
                                    disabled={isCheckingOut}
                                    className="h-11 rounded-lg bg-blue-600 px-4 text-sm font-bold text-white shadow-lg shadow-blue-100 transition hover:bg-blue-700 disabled:opacity-75 disabled:cursor-not-allowed"
                                >
                                    {isCheckingOut ? "Connecting to Stripe..." : "Open Stripe checkout"}
                                </button>
                                {currentPlan !== "trial" && (
                                    <button
                                        type="button"
                                        onClick={() => setShowAllPlans(false)}
                                        disabled={isCheckingOut}
                                        className="h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:opacity-70 disabled:cursor-not-allowed"
                                    >
                                        Hide other plans
                                    </button>
                                )}
                            </>
                        ) : (
                            <button
                                type="button"
                                onClick={() => setShowAllPlans(true)}
                                disabled={isCheckingOut}
                                className="h-11 rounded-lg bg-blue-600 px-4 text-sm font-bold text-white shadow-lg shadow-blue-100 transition hover:bg-blue-700 disabled:opacity-75 disabled:cursor-not-allowed"
                            >
                                See other plans / Upgrade
                            </button>
                        )}
                        <button
                            type="button"
                            onClick={handleBillingPortal}
                            disabled={isCheckingOut}
                            className="h-11 rounded-lg border border-blue-200 bg-white px-4 text-sm font-bold text-blue-700 transition hover:bg-blue-50 disabled:opacity-75 disabled:cursor-not-allowed"
                        >
                            {isCheckingOut ? "Loading portal..." : "Manage billing portal"}
                        </button>
                    </div>
                </div>
                {/* <div className="mt-4 grid gap-3 sm:grid-cols-2">
                    <div className="rounded-xl border border-slate-100 bg-white p-4">
                        <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500">Webhook status</p>
                        <p className="mt-2 text-sm font-semibold text-emerald-700">Ready for subscription events</p>
                    </div>
                    <div className="rounded-xl border border-slate-100 bg-white p-4">
                        <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500">Plan changes</p>
                        <p className="mt-2 text-sm font-semibold text-slate-700">Upgrade or downgrade preview</p>
                    </div>
                </div> */}
            </Panel>

            <Panel title="Payment history" eyebrow="Invoices">
                {isLoadingInvoices && (
                    <div className="text-sm font-bold text-blue-600">Loading invoices...</div>
                )}
                {invoiceError && (
                    <div className="rounded-xl bg-amber-50 p-4 text-sm font-bold text-amber-800">{invoiceError}</div>
                )}
                {!isLoadingInvoices && !invoiceError && invoicesList.length === 0 && (
                    <EmptyState title="No payment history" message="Your account does not have any transactions." />
                )}
                <div className="space-y-3">
                    {invoicesList.map((invoice) => (
                        <div key={invoice.id} className="flex flex-col gap-3 rounded-xl border border-slate-100 p-4 sm:flex-row sm:items-center sm:justify-between">
                            <div>
                                <p className="font-bold text-slate-900">{invoice.id}</p>
                                <p className="text-sm text-slate-500">{invoice.date}</p>
                            </div>
                            <div className="flex items-center gap-4">
                                <p className="font-extrabold text-slate-900">{invoice.amount}</p>
                                {invoice.pdf && (
                                    <a href={invoice.pdf} target="_blank" rel="noopener noreferrer" className="text-xs font-bold text-blue-600 underline">
                                        PDF
                                    </a>
                                )}
                                <StatusBadge tone={invoice.status === "paid" ? "green" : "blue"}>{invoice.status}</StatusBadge>
                            </div>
                        </div>
                    ))}
                </div>
            </Panel>
        </div>
    );
}

export function NotificationsPanel() {
    console.log("Function called: NotificationsPanel");
    const [settings, setSettings] = useState({
        email_on_new_booking: true,
        email_on_cancellation: true,
        send_reminders_24h: true,
    });
    const [isLoadingSettings, setIsLoadingSettings] = useState(false);
    const [settingsError, setSettingsError] = useState("");
    const [notificationForm, setNotificationForm] = useState({
        userId: "",
        token: "",
        title: "",
        body: "",
    });
    const [notificationMessage, setNotificationMessage] = useState("");
    const [isSavingNotification, setIsSavingNotification] = useState(false);

    useEffect(() => {
        let isActive = true;
        setIsLoadingSettings(true);
        setSettingsError("");
        vendorArtistApi.getNotificationSettings()
            .then((response) => {
                if (!isActive) return;
                if (response.success && response.data) {
                    setSettings(response.data);
                }
            })
            .catch((error) => {
                if (!isActive) return;
                setSettingsError(error.message || "Failed to load notification settings.");
            })
            .finally(() => {
                if (!isActive) return;
                setIsLoadingSettings(false);
            });
        return () => {
            isActive = false;
        };
    }, []);

    const handleToggle = async (key) => {
        const updatedSettings = {
            ...settings,
            [key]: !settings[key],
        };
        setSettings(updatedSettings);
        try {
            await vendorArtistApi.saveNotificationSettings(updatedSettings);
        } catch (error) {
            alert(error.message || "Failed to update notification settings.");
            setSettings(settings);
        }
    };

    const updateNotificationField = (field) => (event) => {
        setNotificationForm((current) => ({ ...current, [field]: event.target.value }));
    };

    const runNotificationAction = async (action) => {
        console.log("Function called: runNotificationAction");
        setNotificationMessage("");
        setIsSavingNotification(true);

        try {
            let response;
            if (action === "save") {
                // Vendor platform doesn't use FCM; show email notification log instead
                response = { message: "Token management is not applicable for vendor accounts." };
            } else if (action === "delete") {
                response = { message: "Token management is not applicable for vendor accounts." };
            } else {
                response = { message: "Email notifications are sent automatically when clients book services." };
            }
            setNotificationMessage(response.message || "Notification request sent to backend.");
        } catch (error) {
            console.error("Error caught:", error);
            setNotificationMessage(error.message || "Notification request failed.");
        } finally {
            setIsSavingNotification(false);
        }
    };

    const toggles = [
        {
            key: "email_on_new_booking",
            title: "New booking",
            description: "Send confirmation to customer and vendor",
        },
        {
            key: "send_reminders_24h",
            title: "Reminder",
            description: "Send customer reminder 24 hours before appointment",
        },
    ];

    return (
        <Panel title="Email notifications" eyebrow="Notifications">
            {isLoadingSettings && (
                <div className="mb-4 text-sm font-bold text-blue-600">Loading settings...</div>
            )}
            {settingsError && (
                <div className="mb-4 rounded-xl bg-amber-50 p-4 text-sm font-bold text-amber-800">{settingsError}</div>
            )}
            <div className="grid gap-4 md:grid-cols-3">
                {toggles.map((item) => (
                    <div key={item.key} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                        <div className="flex items-center justify-between gap-3">
                            <span className="grid h-10 w-10 place-items-center rounded-xl bg-blue-50 text-blue-700">
                                <i className="fa-regular fa-envelope" aria-hidden="true" />
                            </span>
                            <button
                                type="button"
                                onClick={() => handleToggle(item.key)}
                                className={`h-6 w-11 rounded-full transition-colors duration-200 p-1 ${settings[item.key] ? "bg-blue-600" : "bg-slate-300"
                                    }`}
                            >
                                <span
                                    className={`block h-4 w-4 rounded-full bg-white transition-transform duration-200 ${settings[item.key] ? "translate-x-5" : "translate-x-0"
                                        }`}
                                />
                            </button>
                        </div>
                        <h3 className="mt-4 font-extrabold text-[#191E49]">{item.title}</h3>
                        <p className="mt-2 text-sm leading-6 text-slate-600">{item.description}</p>
                    </div>
                ))}
            </div>

        </Panel>
    );
}

export function BookingLinkPanel({ profile, services }) {
    console.log("Function called: BookingLinkPanel");
    const currentPlan = profile?.subscription_plan || "trial";
    const currentStatus = profile?.subscription_status || "active";
    const isSubscribed = currentPlan !== "trial" && currentStatus === "active";

    const bookingSlug = profile?.booking_slug || "";
    const bookingUrl = isSubscribed
        ? (bookingSlug ? `${window.location.origin}/book/${bookingSlug}` : "")
        : `${window.location.origin}/book/hidden-slug-upgrade-needed`;
    const [copied, setCopied] = useState(false);
    const [vendorProfile, setVendorProfile] = useState(null);
    const [vendorServices, setVendorServices] = useState([]);

    useEffect(() => {
        if (!bookingSlug) return;
        Promise.all([
            publicApi.getProfileBySlug(bookingSlug),
            publicApi.getServicesBySlug(bookingSlug),
        ]).then(([profileRes, servicesRes]) => {
            setVendorProfile(profileRes.data);
            setVendorServices(servicesRes.data || []);
        }).catch(() => { });
    }, [bookingSlug]);

    const handleCopy = () => {
        if (!bookingUrl || !isSubscribed) return;
        navigator.clipboard.writeText(bookingUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="relative w-full">
            {!isSubscribed && (
                <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-slate-950/20 backdrop-blur-[6px] rounded-[22px] p-6 text-center shadow-inner">
                    <div className="mb-4 grid h-16 w-16 place-items-center rounded-2xl bg-white text-blue-600 shadow-xl border border-blue-50/50 animate-bounce">
                        <i className="fa-solid fa-lock text-2xl" />
                    </div>
                    <h3 className="text-xl font-extrabold text-slate-900">Unlock Booking Portal & Experience</h3>
                    <p className="mt-2 max-w-sm text-sm font-semibold text-slate-600 leading-relaxed">
                        Online client booking portals and live interactive previews are exclusive to subscribed partners.
                    </p>
                </div>
            )}
            <div className={!isSubscribed ? "pointer-events-none select-none filter blur-[4px] opacity-40 w-full" : "w-full"}>
                <div className="space-y-6">
                    <Panel
                        title="Public booking link"
                        eyebrow="Customer booking experience"
                        action={
                            bookingSlug ? (
                                <Link
                                    to={`/book/${bookingSlug}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="h-10 rounded-lg border border-blue-200 px-4 py-2 text-sm font-bold text-blue-700 transition hover:bg-blue-50"
                                >
                                    Open customer page
                                </Link>
                            ) : null
                        }
                    >
                        {bookingSlug ? (
                            <div className="space-y-4">
                                <div className="grid gap-4 lg:grid-cols-[1fr_auto] lg:items-center">
                                    <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 font-mono text-sm font-semibold text-slate-700 break-all">
                                        {bookingUrl}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={handleCopy}
                                        className="h-11 rounded-lg bg-blue-600 px-5 text-sm font-bold text-white shadow-lg shadow-blue-100 transition hover:bg-blue-700"
                                    >
                                        {copied ? (
                                            <><i className="fa-solid fa-check mr-2" aria-hidden="true" />Copied!</>
                                        ) : (
                                            <><i className="fa-regular fa-copy mr-2" aria-hidden="true" />Copy link</>
                                        )}
                                    </button>
                                </div>
                                <p className="text-xs font-semibold text-slate-500">
                                    Share this link with clients so they can book your services online. Anyone with this link can book.
                                </p>
                            </div>
                        ) : (
                            <div className="rounded-xl border border-amber-100 bg-amber-50 p-4">
                                <p className="text-sm font-bold text-amber-800">
                                    <i className="fa-solid fa-triangle-exclamation mr-2" aria-hidden="true" />
                                    No booking slug found. Make sure your artist profile email matches your admin account email.
                                </p>
                            </div>
                        )}
                    </Panel>


                    {vendorProfile ? (
                        <BookingExperience
                            compact
                            vendorProfile={vendorProfile}
                            vendorServices={vendorServices}
                        />
                    ) : bookingSlug ? (
                        <div className="rounded-2xl border border-blue-100 bg-white p-8 text-center">
                            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent" />
                            <p className="mt-3 text-sm font-bold text-blue-700">Loading booking preview...</p>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}